import { ScopesState } from '../interfaces/scopes-state.interface';
import { createReducer, on } from '@ngrx/store';
import * as ScopesActions from './scopes.actions';

const initialState: ScopesState = {
  loading: false,
  scopes: null,
};

export const scopesReducers = createReducer(
  initialState,
  on(ScopesActions.getScopes, state => ({
    ...state,
    loading: true,
  })),
  on(ScopesActions.setScopes, (state, { scopes }) => ({
    ...state,
    loading: false,
    scopes,
  })),
  on(ScopesActions.getScopesFailure, state => ({
    ...state,
    loading: false,
  })),
);
